// extracted by mini-css-extract-plugin
export default {"compare_null_content":"style_compare_null_content__br4zY","empty_compare_img":"style_empty_compare_img__Cp0nf","empty_compare_page":"style_empty_compare_page__Gcr2+"};